module.exports = __webpack_public_path__ + "img/usdc.1671a01d.png";